/**
 * Schakel compacte/tablet middle-bar in op desktop wanneer:
 * - viewport ≤1399px (iPad Pro / tablet / smalle desktop), of
 * - quick links niet meer volledig passen (alleen boven 1399px).
 */
(function () {
  var DESKTOP_MIN = 992;
  var COMPACT_MQ = '(min-width: 992px) and (max-width: 1399px)';
  var root = document.documentElement;
  var rafId = null;
  var compactMq = window.matchMedia(COMPACT_MQ);

  function isOverflowing(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.scrollWidth > el.clientWidth + 2;
  }

  function measureQuickLinksOverflow(quickLinks) {
    if (!quickLinks) return false;

    var links = quickLinks.querySelectorAll('.uf-header-quick-links__link');
    if (!links.length) return false;

    var saved = [];
    var i;

    for (i = 0; i < links.length; i++) {
      saved.push({
        el: links[i],
        flexShrink: links[i].style.flexShrink,
        minWidth: links[i].style.minWidth,
        overflow: links[i].style.overflow,
        maxWidth: links[i].style.maxWidth
      });
      links[i].style.flexShrink = '0';
      links[i].style.minWidth = 'auto';
      links[i].style.overflow = 'visible';
      links[i].style.maxWidth = 'none';
    }

    var total = 0;
    for (i = 0; i < links.length; i++) {
      total += links[i].offsetWidth;
    }

    var seps = quickLinks.querySelectorAll('.uf-header-quick-links__sep');
    for (i = 0; i < seps.length; i++) {
      total += seps[i].offsetWidth;
    }

    for (i = 0; i < saved.length; i++) {
      var item = saved[i];
      item.el.style.flexShrink = item.flexShrink;
      item.el.style.minWidth = item.minWidth;
      item.el.style.overflow = item.overflow;
      item.el.style.maxWidth = item.maxWidth;
    }

    return total > quickLinks.clientWidth + 2;
  }

  function measureCompact() {
    if (window.innerWidth < DESKTOP_MIN) return false;

    /* Tablet-zone: stabiel via media query (geen flip-flop rond 1280px) */
    if (compactMq.matches) return true;

    var quickLinks = document.querySelector('.uf-header-quick-links');
    if (measureQuickLinksOverflow(quickLinks)) return true;
    if (isOverflowing(quickLinks)) return true;

    var links = document.querySelectorAll('.uf-header-quick-links__link');
    for (var i = 0; i < links.length; i++) {
      if (isOverflowing(links[i])) return true;
    }

    var verhaal = document.querySelector('.uf-header-link-verhaal');
    if (isOverflowing(verhaal)) return true;

    var barRight = document.querySelector('.uf-header-bar__right');
    if (isOverflowing(barRight)) return true;

    return false;
  }

  function update() {
    if (window.innerWidth < DESKTOP_MIN) {
      root.classList.remove('uf-header-middle-compact');
      return;
    }

    root.classList.remove('uf-header-middle-compact');
    void document.body.offsetWidth;

    root.classList.toggle('uf-header-middle-compact', measureCompact());
  }

  function scheduleUpdate() {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      update();
    });
  }

  function init() {
    var bar = document.querySelector('.header .middle_bar');
    if (!bar) return;

    update();

    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('orientationchange', scheduleUpdate);
    if (compactMq.addEventListener) {
      compactMq.addEventListener('change', scheduleUpdate);
    } else if (compactMq.addListener) {
      compactMq.addListener(scheduleUpdate);
    }

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(scheduleUpdate);
      [
        '.uf-middle-bar',
        '.uf-header-bar__left',
        '.uf-header-bar__right',
        '.uf-header-quick-links',
        '.uf-header-search-group'
      ].forEach(function (sel) {
        var el = bar.querySelector(sel);
        if (el) ro.observe(el);
      });
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleUpdate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
